import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getLanguageText } from "../../services/GlobalUtil";
import moment from "moment";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import hIcon from "../../assets/images/logo_print.png";
import checkPIcon from "../../assets/images/btn_checkB_p.png";
import checkNIcon from "../../assets/images/btn_checkB_n.png";
import TestDriveDiv from "../../components/common/TestDriveDiv";
import ConditionDiv from "../../components/common/ConditionDiv";
import PressureDiv from "../../components/common/PressureDiv";
import VarianceDiv from "../../components/common/VarianceDiv";
import TimeDl from "../../components/common/TimeDl";

const SheetWrapDiv = styled.div`
  width: 21cm;
  height: 29.7cm;
  color: #000;
  position: relative;

  * {
    font-family: "Arial", "Gulim";
  }

  h1 {
    margin-bottom: 10px;
    text-align: right;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 15px;
    letter-spacing: -0.2px;
    text-align: center;

    em {
      font-size: 32px;
      margin-right: 10px;
      letter-spacing: -0.5px;
      text-transform: uppercase;
    }
  }
`;

const InfoWrapDiv = styled.div`
  margin: 0 -10px 5px;

  div {
    display: table;
    border-spacing: 10px 5px;
    width: 100%;
  }
  dl {
    width: 33.333%;
    display: table-cell;
    background-color: #f6f3f2;
    padding: 23px 5px 5px;
    border: 1px solid #e8e1de;
    box-sizing: border-box;
    height: 50px;
    position: relative;
    vertical-align: middle;
    -webkit-print-color-adjust: exact;
  }
  dt {
    position: absolute;
    top: 5px;
    left: 5px;
    -webkit-print-color-adjust: exact;
  }
  dd {
    text-align: center;
    font-weight: bold;
    font-size: 13px;
  }
`;

const ContentWrapDiv = styled.div`
  height: 680px;
  margin: 0 -7px;

  div {
    display: table-cell;
    vertical-align: top;
  }
  dl {
    margin: 0 7px 12px;
  }
  dt {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 5px;
    background-color: #e4dcd3;
    padding: 7px 7px 5px;
    -webkit-print-color-adjust: exact;
  }
  dd {
    line-height: 18px;
    padding: 0px 5px 0px 20px;
    position: relative;

    img {
      position: absolute;
      left: 0;
      top: 1px;
      cursor: pointer;
    }
  }
`;

const ContentColWrapDiv = styled.div`
  width: 500px;
`;

const BottomWrapDiv = styled.div`
  position: absolute;
  width: 21cm;
  bottom: 0;

  li {
    background-color: #f6f3f2;
    border: 1px solid #e8e1de;
    box-sizing: border-box;
    width: 32.6%;
    display: inline-table;
    height: 130px;
    vertical-align: middle;
    padding: 5px;
    position: relative;
    margin-right: 5px;
    -webkit-print-color-adjust: exact;

    h4 {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
    }

    p {
      padding-top: 30px;
    }
  }
`;

const PdiDetailPrintPage = React.forwardRef((props, ref) => {
  let rowCount = 5;
  const pages = [];
  let currentPage = { left: [], right: [] };
  const { t } = useTranslation();
  const { unit, info, add, auto, visual, testDrive, wheel, final } = props;

  const sections = [];

  if (auto && auto.length > 0) {
    sections.push({
      title: t("L0215"),
      items: auto.filter((autoData) =>
        String(autoData.itemCode).startsWith("3")
      ),
    });
  }
  if (auto && auto.length > 0) {
    sections.push({
      title: t("L0231"),
      items: auto?.filter((autoData) =>
        String(autoData.itemCode).startsWith("4")
      ),
    });
  }
  if (auto && auto.length > 0) {
    sections.push({
      title: t("L0232"),
      items: auto?.filter((autoData) =>
        String(autoData.itemCode).startsWith("5")
      ),
    });
  }
  if (visual && visual.length > 0) {
    sections.push({
      title: t("L0217"),
      items: visual
        .filter((visualData) => {
          return visualData.type === "ThreeLevelCheck";
        })
        .map((visualData) => ({
          result: visualData.value === "G" ? 0 : 1,
          inspItem: `${getLanguageText(visualData.category)} 
        - ${getLanguageText(visualData.subCategory)}`,
        })),
    });
  }

  sections.forEach((section, sectionIndex) => {
    if (section.title) {
      if (rowCount === 90) {
        pages.push(currentPage);
        currentPage = { left: [], right: [] };
        rowCount = 0;
      }
      if (rowCount < 45) {
        currentPage.left.push({ type: "header", title: section.title });
      } else {
        currentPage.right.push({ type: "header", title: section.title });
      }
      rowCount++;
    }
    section.items.forEach((item, itemIndex) => {
      if (rowCount === 90) {
        pages.push(currentPage);
        currentPage = { left: [], right: [] };
        rowCount = 0;
      }
      if (rowCount < 45) {
        currentPage.left.push({ type: "data", item: item });
      } else {
        currentPage.right.push({ type: "data", item: item });
      }
      rowCount++;
    });
  });
  if (rowCount > 0) {
    pages.push(currentPage);
  }

  const header = () => {
    return (
      <>
        <div style={{ height: "20px" }}></div>
        <h1>
          <img src={hIcon} alt="icon" />
        </h1>
        <h2>
          <em>{t("L0330")}</em>
        </h2>
        <InfoWrapDiv>
          <div>
            <dl>
              <dt>{t("L0702")} : </dt>
              <dd>
                {info && info.loc && info.loc.includes("/")
                  ? (() => {
                      const [left, right] = info.loc.split("/");
                      return `${right} ( ${left})`;
                    })()
                  : info && info.loc
                  ? info.loc
                  : ""}
              </dd>
            </dl>
            <dl>
              <dt>{t("L0686")} : </dt>
              <dd>{info.vehicle}</dd>
            </dl>
            <dl>
              <dt>{t("L0703")} : </dt>
              <dd>
                {info.mileage} {unit?.distanceDesc || "Km"}
              </dd>
            </dl>
          </div>
          <div>
            <dl>
              <dt>{t("L0671")} : </dt>
              <dd>{info.vin}</dd>
            </dl>
            <dl>
              <dt>{t("L0156")} : </dt>
              <dd>{info.inspector}</dd>
            </dl>
            <dl>
              <dt>{t("L0132")} : </dt>
              <dd>
                {info.inspDate
                  ? moment(info.inspDate).format("YYYY-MM-DD HH:mm:ss")
                  : ""}
              </dd>
            </dl>
          </div>
        </InfoWrapDiv>
        <div style={{ height: "12px" }}></div>
      </>
    );
  };

  return (
    <div ref={ref}>
      {pages.map((page, pageIndex) => (
        <React.Fragment key={`page-${pageIndex}`}>
          <SheetWrapDiv>
            {header()}
            <ContentWrapDiv>
              <div style={{ width: "500px" }}>
                {pageIndex === 0 && (
                  <>
                    <dl>
                      <dt>{t("L0402")}</dt>
                      <ListWrapDiv>
                        <table style={{ tableLayout: "fixed" }}>
                          <colgroup>
                            <col style={{ width: "25%" }}></col>
                            <col style={{ width: "25%" }}></col>
                            <col style={{ width: "25%" }}></col>
                            <col style={{ width: "25%" }}></col>
                          </colgroup>
                          <thead>
                            <tr>
                              <th>{t("L0403")}</th>
                              <th>{t("L0680")}</th>
                              <th>{t("L0404")}</th>
                              <th>{t("L0405")}</th>
                            </tr>
                            <tr>
                              <td>{add.batteryVolt} V</td>
                              <td>{add.batterySoc} %</td>
                              <td>{add.cca}</td>
                              <td>{add.roNo}</td>
                            </tr>
                          </thead>
                        </table>
                      </ListWrapDiv>
                    </dl>
                  </>
                )}
                <dl>
                  {page.left.map((obj, index) => (
                    <React.Fragment key={`left-${index}`}>
                      {obj.type === "header" ? (
                        <>
                          <br />
                          <dt>{obj.title}</dt>
                        </>
                      ) : obj.type === "data" ? (
                        <dd>
                          <img
                            src={
                              obj.item.result === 0 ? checkPIcon : checkNIcon
                            }
                            alt="CheckBox"
                          />
                          {obj.item.inspItem}
                        </dd>
                      ) : null}
                    </React.Fragment>
                  ))}
                </dl>
              </div>
              <div style={{ width: "500px" }}>
                <dl>
                  {page.right.map((obj, index) => (
                    <React.Fragment key={`right-${index}`}>
                      {obj.type === "header" ? (
                        <>
                          <br />
                          <dt>{obj.title}</dt>
                        </>
                      ) : obj.type === "data" ? (
                        <dd>
                          <img
                            src={
                              obj.item.result === 0 ? checkPIcon : checkNIcon
                            }
                            alt="CheckBox"
                          />
                          {obj.item.inspItem}
                        </dd>
                      ) : null}
                    </React.Fragment>
                  ))}
                </dl>
              </div>
            </ContentWrapDiv>
          </SheetWrapDiv>
          <div style={{ pageBreakBefore: "always" }}></div>
        </React.Fragment>
      ))}
      {/* 
      <SheetWrapDiv>
        {header()}
        <div>
          <div>
            <dl>
              <ContentWrapDiv style={{ height: "50px" }}>
                <dt> &nbsp;{t("L0737")}</dt>
              </ContentWrapDiv>
              <TestDriveDiv className={"mt10"}>
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <colgroup>
                    <col style={{ width: "24%" }} />
                    <col style={{ width: "52%" }} />
                    <col style={{ width: "24%" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>{t("L0393")}</th>
                      <th>{t("L0181")}</th>
                      <th>{t("L0748")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="items">
                      <td>
                        <ConditionDiv>
                          <dl className="ng">
                            <dt>{t("L0743")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className="ng">
                            <dt>{t("L0744")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className="ng">
                            <dt>{t("L0738")}</dt>
                            <dd>0</dd>
                          </dl>
                        </ConditionDiv>
                      </td>
                      <td>
                        <PressureDiv className={"w100"}>
                          <dl className={"p_fl na"} style={{ left: "0px" }}>
                            <dt>{t("L0739")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className={"p_fr ok"} style={{ right: "0px" }}>
                            <dt>{t("L0740")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className={"p_rl ok "} style={{ left: "0px" }}>
                            <dt>{t("L0741")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className={"p_rr ng"} style={{ right: "0px" }}>
                            <dt>{t("L0742")}</dt>
                            <dd>0</dd>
                          </dl>
                        </PressureDiv>
                      </td>
                      <td>
                        <VarianceDiv>
                          <dl className={"v_flfr ok"}>
                            <dt>{t("L0746")}</dt>
                            <dd>0</dd>
                          </dl>
                          <dl className={"v_rlrr ok"}>
                            <dt>{t("L0747")}</dt>
                            <dd>0</dd>
                          </dl>
                        </VarianceDiv>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <TimeDl>
                          <dt>{t("L0934")}</dt>
                          <dd></dd>
                          <dt>{t("L0935")}</dt>
                          <dd></dd>
                        </TimeDl>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TestDriveDiv>
            </dl>
          </div>
        </div>
        <BottomWrapDiv>
          <ul>
            <li>
              <h4>{t("L1018")} :</h4>
              <p></p>
            </li>
            <li>
              <h4>{t("L0706")} :</h4>
              <p></p>
            </li>
            <li>
              <h4>{t("L0995")} :</h4>
              <p style={{ textAlign: "left" }}>{t("L0132")} :</p>
              <p style={{ textAlign: "left" }}>{t("L0995")} :</p>
            </li>
          </ul>
        </BottomWrapDiv>
      </SheetWrapDiv>
       */}
    </div>
  );
});

export default PdiDetailPrintPage;
